import React from 'react'

const ErrorPage = () => {
    
    return (
        <div>
            
            NAMASTE

        </div>
    )
}

export default ErrorPage